import React from 'react';
import SimpleTracker from './SimpleTracker';
import { nextInjuryNumber } from './services/applicationCounterService';

const INJURY_BODY_PARTS = [
  'Head', 'Neck', 'Back', 'Shoulder', 'Arm', 'Hand', 'Finger',
  'Torso', 'Hip', 'Leg', 'Knee', 'Foot', 'Eye', 'Other', 'Multiple'
];

const INJURY_SEVERITY = ['Minor', 'Moderate', 'Severe', 'Critical'];

const config = {
  collectionName: 'injuries',
  breadcrumbLabel: 'Injury Reports',
  breadcrumbIcon: '🩹',
  pageTitle: 'Injury Reports',
  entityNoun: 'Injury Report',
  entityNounPlural: 'Injury Reports',
  numberPrefix: 'IJ',
  statusOptions: ['Open', 'Investigating', 'Treatment', 'Resolved', 'Closed', 'Cancelled'],
  statusColors: {
    'Open': '#dc2626',
    'Investigating': '#f59e0b',
    'Treatment': '#3b82f6',
    'Resolved': '#16a34a',
    'Closed': '#6b7280',
    'Cancelled': '#9ca3af'
  },
  extraFields: [
    {
      key: 'injuredPersonName',
      label: 'Injured Person Name',
      type: 'text',
      fullWidth: true
    },
    {
      key: 'bodyPart',
      label: 'Body Part Affected',
      type: 'select',
      options: INJURY_BODY_PARTS
    },
    {
      key: 'severity',
      label: 'Severity',
      type: 'select',
      options: INJURY_SEVERITY,
      defaultValue: 'Minor'
    },
    {
      key: 'incidentDateTime',
      label: 'Incident Date & Time',
      type: 'datetime-local'
    },
    {
      key: 'location',
      label: 'Location',
      type: 'text',
      fullWidth: true
    },
    {
      key: 'medicalAttention',
      label: 'Medical Attention Received',
      type: 'textarea',
      fullWidth: true,
      rows: 2
    }
  ],
  nextNumberFn: nextInjuryNumber
};

function InjuryReportsApp() {
  return <SimpleTracker config={config} />;
}

export default InjuryReportsApp;
